<template>
	<div>
		<div style="height:60px;">
			<p style="height:50px; padding:15px; font-size:30px;"><b>Vessel : </b>{{vessel_name}}</p>
			<hr/>
		</div>
		<div>
			<div v-for="(data,index) in joborders" style="height:95px;">
				<div style="height:50px; padding:15px; font-size:16px;" :id="'jobInfoText_'+index">{{data}}</div>
				<div :key="index+'_'+typeSelectKey">
					<input :id="'type-0-'+index" :value="'Arrival'" v-model="typeSelect[index]" type="radio" style="width:50px;">Arrival</input>
					<input :id="'type-1-'+index" :value="'Service'" v-model="typeSelect[index]" type="radio" style="width:50px;">Service</input>
					<input :id="'type-2-'+index" :value="'Departure'" v-model="typeSelect[index]" type="radio" style="width:50px;">Departure</input>
				</div>
				<hr/>
			</div>
		</div>
		<div style="height:35px; padding:5px 5px 0px">
			<button :disabled="button_name=='Add'" v-on:click="changeButtonName('Add')">Add</button>
			<button :disabled="button_name=='Delete'" v-on:click="changeButtonName('Delete')">Delete</button>
		</div>
		<layout-1
			:table_name="'Port Stays'"
			:id=pageid
			:searchbar=false
			:termchange=false
			:term=term
			:button_name="button_name"
			:button_perm="'82'"
			v-on:search="setData"
			v-on:select="selectPortStay"
			:style="'width:100%; height:calc(100vh - 100px - '+(95*joborders.length+90)+'px);'">
		</layout-1>
		<div class="nav-bar">
			<button v-on:click="addNew()">Add To New</button>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.ADD_PORT_STAYS_PAGE,
			pageid2:PAGES.ADD_PORT_STAYS_JOBORDERS_PAGE,
			joborders:[],
			typeSelect:[],
			typeSelectKey:0,
			column_data:[],
			vessel_name:"",
			button_name:"Add",
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.joborders = this.term.split(',');
		this.getJobData();
	},
	methods: {
		changeButtonName(name){
			this.button_name = name;
		},
		selectPortStay(value){

			var do_delete = this.button_name=='Delete';

			if(!do_delete){
				if(this.verifyData(value[0])==false) { return; }
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid,
						data:[
							value[0],
						],
						do_delete:do_delete,
						joborders:this.joborders,
						portStayTypes:this.typeSelect,
					}
				}
			).then((res)=>{
				alert(res.data.messages.join('\n'));
				router.go(-1);
			})

		},
		setData(data){
			this.column_data=data;
		},
		addNew(){

			if(this.verifyData('null')==false) { return; }

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid,
						data:[
							null,
						],
						joborders:this.joborders,
						portStayTypes:this.typeSelect,
					}
				}
			).then((res)=>{
				alert(res.data.messages.join('\n'));
				router.go(-1);
			})

		},
		verifyData(value){
			if(this.typeSelect.length!=this.joborders.length){
				alert("Select Port Stay Type for all Joborders");
				return false;
			}

			var hasArrival = false;
			var hasDeparture = false;

			for(var i = 0;i<this.typeSelect.length;i++){
				if(this.typeSelect[i]==null){
					alert("Select Port Stay Type for all Joborders");
					return false;
				}
				else if(this.typeSelect[i]=='Arrival')
				{
					if(!hasArrival){
						hasArrival = true;
					}else{
						alert("Select only one Arrival");
						return false;
					}
				}
				else if(this.typeSelect[i]=='Departure')
				{
					if(!hasDeparture){
						hasDeparture = true;
					}else{
						alert("Select only one Departure");
						return false;
					}
				}
			}

			for(var i = 0;i<this.column_data.length;i++){
				if(this.column_data[i][8]=='Arrival' && this.column_data[i][0]==value)
				{
					if(!hasArrival){
						hasArrival = true;
					}else{
						alert("Select only one Arrival");
						return false;
					}
				}
				else if(this.column_data[i][8]=='Departure' && this.column_data[i][0]==value)
				{
					if(!hasDeparture){
						hasDeparture = true;
					}else{
						alert("Select only one Departure");
						return false;
					}
				}
			}

			return true;
		},
		getJobData(){

			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						data:[
							this.joborders
						],
					}
				}
			).then((res) => {

				for(var i = 0;i<res.data.data.column_data.length;i++){

					var text = ""

					if(res.data.data.column_data[i][1]!=null){
						this.vessel_name = res.data.data.column_data[i][1];
					}

					for(var j = 0;j<res.data.data.column_names.length;j++){
						text+="<div style='float:left; height:30px'>"
						text+="<b>"+res.data.data.column_names[j]+":</b> "
						if(j==0){
							text+="<p style='float:right; height:30px;'>"+res.data.data.column_data[i][j]+"</p>"
						}else{
							text+=res.data.data.column_data[i][j]
						}
						text+="&emsp;</div>"
					}
					document.getElementById("jobInfoText_"+i).innerHTML = text;

					if(res.data.data.column_data[i][3]=='AAA' || res.data.data.column_data[i][3]=='COM'){
						this.typeSelect[i] = "Arrival";
					}else if(res.data.data.column_data[i][3]=='AAD') {
						this.typeSelect[i] = "Departure";
					}else{
						this.typeSelect[i] = "Service";
					}

				}
				this.typeSelectKey++;

			});
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/components/add/Add_Port_Stays.vue